module.exports = __webpack_public_path__ + "static/fonts/Fact-BlackItalic.a8d0381.ttf";